import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "./authService";
//check if user and token are defined
let user = null;
let token = null;
let keys = [];

if (localStorage.getItem("user") != null) {
  user = { user: JSON.parse(localStorage.getItem("user") || "{}") };
} else {
  user = null;
}

if (localStorage.getItem("key") != null) {
  keys = JSON.parse(localStorage.getItem("keys"));
} else {
  keys = [];
}

if (localStorage.getItem("token") === undefined) {
  token = null;
} else {
  token = JSON.parse(localStorage.getItem("token"));
}

const initialState = {
  user: user,
  token: token,
  keys: keys,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  botMemory: [],
};

//register user
export const register = createAsyncThunk(
  "auth/register",
  async (user, thunkAPI) => {
    try {
      return await authService.register(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.error || error.response.data.message)) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update first time user

export const updateFirstTimeUser = createAsyncThunk(
  "auth/updateFirstTimeUser",
  async (userDetails, thunkAPI) => {
    try {
      const response = await authService.updateFirstTimeUser({
        userDetails,
        token,
      });
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//update user
export const updateUserPersonal = createAsyncThunk(
  "auth/updateUserPersonal",
  async (data, thunkAPI) => {
    try {
      //const user_token = thunkAPI.getState().auth.token;
      const response = await authService.updateUserPersonal({
        data,
        token,
      });
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  await authService.logout();
});

//login user
export const login = createAsyncThunk("auth/login", async (user, thunkAPI) => {
  try {
    return await authService.login(user);
  } catch (error) {
    // error.message already has either front‐end or back‐end text
    return thunkAPI.rejectWithValue(error.message);
  }
});

//generate verificaion token
export const generateVerificationToken = createAsyncThunk(
  "auth/generateVerificationToken",
  async (data, thunkAPI) => {
    try {
      return await authService.generateVerificationToken(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//delete verificaion token
export const deleteVerificationToken = createAsyncThunk(
  "auth/deleteVerificationToken",
  async (data, thunkAPI) => {
    try {
      return await authService.deleteVerificationToken(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//edit any user password
export const resetUserPassword = createAsyncThunk(
  "auth/resetUserPassword",
  async (data, thunkAPI) => {
    try {
      return await authService.resetUserPassword(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get current user memory of bot
export const getUserBotMemory = createAsyncThunk(
  "auth/getUserBotMemory",
  async (data, thunkAPI) => {
    try {
      return await authService.getUserBotMemory(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//get otp
export const getOTP = createAsyncThunk(
  "auth/getOTP",
  async (data, thunkAPI) => {
    try {
      return await authService.getOTP(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//forgetPassword
export const forgetPassword = createAsyncThunk(
  "auth/forgetPassword",
  async (data, thunkAPI) => {
    try {
      return await authService.forgetPassword(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//bugreport
export const _bugReport_ = createAsyncThunk(
  "auth/bugReport",
  async (data, thunkAPI) => {
    try {
      return await authService._bugReport_(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get user by id
export const getUserByID = createAsyncThunk(
  "auth/getUserByID",
  async (id, thunkAPI) => {
    try {
      //const token = thunkAPI.getState().auth.token;
      const response = await authService.getUser(id, token);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// create a new session and fetch memory
export const createNewMemorySession = createAsyncThunk(
  "auth/createNewMemorySession",
  async ({ user_id, bot_id, sessionTitle }, thunkAPI) => {
    try {
      const response = await authService.createNewMemorySession(
        user_id,
        bot_id,
        sessionTitle
      );
      if (!response.session_id) {
        return thunkAPI.rejectWithValue("Session ID missing from response");
      }

      return response; // Ensure this is returned
    } catch (error) {
      console.error("Error caught in thunk:", error);
      return thunkAPI.rejectWithValue(error.message || "Unknown error");
    }
  }
);

// Get a specific session
export const getSession = createAsyncThunk(
  "auth/getSession",
  async (session_id, thunkAPI) => {
    try {
      return await authService.getSession(session_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Delete a session
export const deleteSession = createAsyncThunk(
  "auth/deleteSession",
  async (session_id, thunkAPI) => {
    try {
      return await authService.deleteSession(session_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//edit any user password
export const UpdateCurrentUserPassword = createAsyncThunk(
  "auth/UpdateCurrentUserPassword",
  async (data, thunkAPI) => {
    try {
      return await authService.UpdateCurrentUserPassword(data);
    } catch (error) {
      const message =
        error.response && error.response.data && error.response.data.status;
      error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const googleLogin = createAsyncThunk("auth/googleLogin", async () => {
  window.location.href = authService.getGoogleLoginUrl();
});

export const googleRegister = createAsyncThunk(
  "auth/googleRegister",
  async () => {
    window.location.href = authService.getGoogleRegisterUrl();
  }
);

// Create public demo session thunk
export const createPublicDemoSession = createAsyncThunk(
  "auth/createPublicDemoSession",
  async (_, thunkAPI) => {
    try {
      return await authService.createPublicDemoSession();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetUserComplete: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
      state.token = null;
      token = null;
      localStorage.clear();
    },
    resetUser: (state) => {
      state.user = null;
      state.token = null;
      token = null;
      localStorage.clear();
    },
    setCredentials: (state, action) => {
      const { token, user } = action.payload;

      if (!state.user) {
        state.user = { user: null, token: null };
      }

      if (token) {
        state.token = token;
        state.user.token = token;
        localStorage.setItem("token", JSON.stringify(token));
      }

      if (user) {
        state.user.user = user;
        localStorage.setItem(
          "user",
          JSON.stringify({ ...state.user.user, token: state.user.token })
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.token = action.payload.token;
      })
      .addCase(register.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.user = null;
      })
      .addCase(updateUserPersonal.pending, (state) => {
        //state.isLoading = true;
      })
      .addCase(updateUserPersonal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // guard against null/undefined payload:
        const payload = action.payload || {};
        state.message = payload.status || "";
        if (payload.userDetails) {
          state.user.user.first_name = payload.userDetails.first_name;
          state.user.user.last_name = payload.userDetails.last_name;
          const updatedUser = {
            ...state.user.user,
            first_name: payload.userDetails.first_name,
            last_name: payload.userDetails.last_name,
          };
          localStorage.setItem("user", JSON.stringify(updatedUser));
        }
      })
      .addCase(updateUserPersonal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateFirstTimeUser.pending, (state) => {
        //state.isLoading = true;
      })
      .addCase(updateFirstTimeUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.user.user.first_time_user = action.payload.first_time_user;

        const updatedUser = {
          ...state.user.user,
          first_time_user: action.payload.first_time_user, // Update specific field
        };
        // Update localStorage
        localStorage.setItem("user", JSON.stringify({ ...updatedUser }));
      })
      .addCase(updateFirstTimeUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
      })
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.token = action.payload.token;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.user = null;
      })
      .addCase(generateVerificationToken.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(generateVerificationToken.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.user.user.verification_token = action.payload.verification_token;
        const updatedUser = {
          ...state.user.user,
          verification_token: action.payload,
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      })
      .addCase(generateVerificationToken.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(deleteVerificationToken.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteVerificationToken.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.user.user.verification_token = "";
        localStorage.setItem("user", JSON.stringify(state.user.user));
      })
      .addCase(deleteVerificationToken.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(resetUserPassword.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(resetUserPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
      })
      .addCase(resetUserPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getUserBotMemory.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getUserBotMemory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;

        const bot_id = action.meta.arg.bot_id;
        const memoryData = action.payload;
        const existingBotIndex = state.botMemory.findIndex(
          (memory) => memory.bot_id === bot_id
        );

        if (existingBotIndex !== -1) {
          state.botMemory[existingBotIndex] = {
            ...state.botMemory[existingBotIndex],
            memory: {
              ...memoryData.memory,
              sessions: memoryData.memory.sessions || {},
            },
          };
        } else {
          state.botMemory.push({
            bot_id: bot_id,
            memory: {
              sessions: memoryData.memory.sessions || {},
            },
          });
        }
      })
      .addCase(getUserBotMemory.rejected, (state, action) => {
        const bot_id = action.meta.arg.bot_id;
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message;
        // Handle no memory data for the bot
        const existingBotIndex = state.botMemory.findIndex(
          (memory) => memory.bot_id === bot_id
        );
        if (existingBotIndex !== -1) {
          state.botMemory[existingBotIndex] = {
            ...state.botMemory[existingBotIndex],
            memory: {},
          };
        } else {
          state.botMemory.push({
            bot_id: bot_id,
            memory: {},
          });
        }
        state.message = "No memory data available for this bot.";
      })
      .addCase(getOTP.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
      })
      .addCase(getOTP.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message;
      })
      .addCase(forgetPassword.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(forgetPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
      })
      .addCase(forgetPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message;
      })
      .addCase(_bugReport_.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(_bugReport_.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
      })
      .addCase(_bugReport_.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message;
      })
      .addCase(getUserByID.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getUserByID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
      })
      .addCase(getUserByID.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message;
      })
      .addCase(createNewMemorySession.pending, (state) => {
        //state.isLoading = true;
      })
      .addCase(createNewMemorySession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        const { bot_id, sessionTitle } = action.meta.arg; // Pass sessionTitle when dispatching
        const sessionId = action.payload.session_id;
        const lastUpdated = new Date().toISOString(); // Assuming timestamp is not returned

        if (!sessionId) {
          console.error("Session ID missing from response");
          return;
        }
        const existingBotIndex = state.botMemory.findIndex(
          (memory) => memory.bot_id === bot_id
        );
        if (existingBotIndex !== -1) {
          const botMemory = state.botMemory[existingBotIndex];
          botMemory.memory.sessions = {
            ...botMemory.memory.sessions, // Copy previous sessions to ensure changes are detected
            [sessionTitle]: {
              id: sessionId,
              last_updated: lastUpdated,
            },
          };
        } else {
          state.botMemory.push({
            bot_id,
            memory: {
              sessions: {
                [sessionTitle]: {
                  id: sessionId,
                  last_updated: lastUpdated,
                },
              },
            },
          });
        }
      })
      .addCase(createNewMemorySession.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to create a new session.";
      })
      .addCase(getSession.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(getSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(getSession.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to fetch session.";
      })

      // Delete Session
      .addCase(deleteSession.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(deleteSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;

        const sessionId = action.payload.session_id;
        state.botMemory.forEach((memory) => {
          if (memory.memory.sessions) {
            Object.keys(memory.memory.sessions).forEach((query) => {
              if (memory.memory.sessions[query].id === sessionId) {
                delete memory.memory.sessions[query];
              }
            });
          }
        });
      })
      .addCase(deleteSession.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to delete session.";
      })
      .addCase(UpdateCurrentUserPassword.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(UpdateCurrentUserPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.status;
      })
      .addCase(UpdateCurrentUserPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(createPublicDemoSession.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPublicDemoSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // Save user/token in state and localStorage like login
        if (action.payload.token) {
          state.token = action.payload.token;
          localStorage.setItem("token", JSON.stringify(action.payload.token));
        }
        if (action.payload) {
          state.user = action.payload;
          localStorage.setItem("user", JSON.stringify(action.payload));
        }
      })
      .addCase(createPublicDemoSession.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.user = null;
      });
  },
});
export const { resetUserComplete, resetUser, setCredentials } =
  authSlice.actions;
export default authSlice.reducer;
